import { Box } from '@mui/material';
import type { LucideIcon } from 'lucide-react';

import { customPalette } from '@shared/theme/StyleProvider';

export const SelectStartIcon = ({ icon: Icon }: { icon: LucideIcon }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      ml: 0.75,
      mr: 0.5,
      color: customPalette.gray500,
    }}
  >
    <Icon size={18} />
  </Box>
);
